<template>
<div>
    <b-img center class="screenshot" :src="screenshotURL" /> 
    <div class="screenshot-ts"><b-icon icon="arrow-clockwise"/>{{ screenshotTimestamp }}</div>

</div>
</template>

<script>

export default {
    props: ['item'],
    data() {
        return {
            notFoundImage: "/traveller-ui/static/traveller/img/not-found-960x540.png",
        }
    },
    computed: {
        infopoint() {
            return this.item;
        },
        screenshotURL(){
            return (this.infopoint && this.infopoint.screenshot) ? this.infopoint.screenshot : this.notFoundImage ;
        },
        screenshotTimestamp(){
            return (this.infopoint && this.infopoint.screenshotTime) ? this.infopoint.screenshotTime : "-" ;
        },
        infopointId(){
            return this.infopoint.infopointLabel
        },
        screenshots() {
            return this.$store.state.infopoint.screenshots;
        },
        XscreenshotURL(){
            var screenshot = this.notFoundImage;
             if(this.infopoint && this.screenshots){
                var iScreenshot = this.screenshots[this.infopoint.infopointLabel];
                if(iScreenshot && iScreenshot.base64)
                    screenshot =  iScreenshot.base64    
            }
            return screenshot;
        },
    }
    
}
</script>
